import { gql } from '@parkchirp/api-client';

export * from './getSenderAddress';

export const GET_BULK_EMAIL_OPTIONS = gql`
    query getBulkEmailOptions(
        $facilityId: String!
        $customerType: String!
        $filters: [Filter!]!
        $order: SortOrder!
    ) {
        getBulkEmailOptions(
            facilityId: $facilityId
            customerType: $customerType
            filters: $filters
            order: $order
        ) {
            id
            firstName
            lastName
            email
            subscriptionName
            accountId
            validationOnly
            status
            suspensionStatus
            terminationStatus
            rateName
        }
    }
`;

export const GET_BULK_EMAIL_HISTORY = gql`
    query getBulkEmailHistory(
        $facilityId: String!
    ) {
        getBulkEmailHistory(
            facilityId: $facilityId
        ) {
            id
            subject
            content
            date
            sentBy
            attachments {
                id
                fileName
                bucketPath
                createdAt
            }
        }
    }
`;
